/**
 * @file The Overlay Container component.
 * @author Heino Lenting
 */
import { OnInit, ComponentFactoryResolver, Injector, ViewContainerRef } from '@angular/core';
import { OverlayService } from '../../core/overlay.service';
import { OverlayProvider } from '../overlay-provider';
import { ComponentRegistry } from '../../core/component-registry';
var OverlayContainerComponent = /** @class */ (function () {
    function OverlayContainerComponent(overlayService, containerRef, factoryResolver) {
        this.overlayService = overlayService;
        this.containerRef = containerRef;
        this.factoryResolver = factoryResolver;
        this.component = null;
    }
    OverlayContainerComponent.prototype.ngOnInit = function () {
        var _this = this;
        var params = this.overlayService.getParams();
        if (params === null || this.component === null) {
            return;
        }
        var component = ComponentRegistry.getComponent('overlay', this.component.component);
        // Nu zonder this.configurationsService.configuration. Zie onder oude code.
        if (this.containerRef.length > 0) {
            this.containerRef.clear();
        }
        var componentFactory = this.factoryResolver.resolveComponentFactory(component);
        // https://stackoverflow.com/questions/45585606/staticinjector-vs-reflectiveinjector-in-angular
        var injector = Injector.create([
            {
                provide: OverlayProvider,
                useFactory: function () {
                    return new OverlayProvider(params, _this.component.configuration);
                },
                deps: []
            }
        ]);
        this.containerRef.createComponent(componentFactory, 0, injector, []);
        // ReflectiveInjector is deprecated #3479
        // const providers = ReflectiveInjector.resolve([{
        //     provide: OverlayProvider,
        //     useFactory: (): OverlayProvider => {
        //         return new OverlayProvider(params, this.component.configuration);
        //     }
        // }]);
        // const injector = ReflectiveInjector.fromResolvedProviders(providers, this.containerRef.parentInjector);
        // Scroll to top to make overlay always visible in the view port
        window.scrollTo(0, 0);
    };
    /**
     * Handles the 'close' action
     */
    OverlayContainerComponent.prototype.closeOverlay = function () {
        this.overlayService.closeOverlay();
    };
    return OverlayContainerComponent;
}());
export { OverlayContainerComponent };
